import { memo } from 'react';
import { css } from '@emotion/react';
import { Logo } from '@frontend/assets';
import { useTranslation } from '@frontend/i18n';
import { titleCase } from '@frontend/string';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import InsuranceActiveStatusChip from '../../../assets/Insurance-Active-Status-Chip.png';
import InsuranceInactiveStatusChip from '../../../assets/Insurance-Inactive-Status-Chip.png';

type PrintableHeaderProps = {
  firstName: string;
  insuranceStatus: string;
};

export const PrintableHeader = memo(({ firstName, insuranceStatus }: PrintableHeaderProps) => {
  const { t } = useTranslation('insuranceEligibilityReport');

  const reportFirstName = firstName ? `${titleCase(firstName)}'s` : '';

  if (!reportFirstName) return null;

  const isActiveInsurance = insuranceStatus?.toLowerCase() === 'active';
  const isInActiveInsurance = insuranceStatus?.toLowerCase() === 'inactive';
  const shouldShowInsuranceStatus = !!insuranceStatus && (isActiveInsurance || isInActiveInsurance);

  return (
    <section css={printableHeaderStyles}>
      <div css={{ display: 'flex', gap: theme.spacing(2), alignItems: 'baseline' }}>
        <Heading>{reportFirstName}</Heading>
        <Heading level={1} style={{ fontWeight: theme.font.weight.regular }}>
          {t('Eligibility Report')}
        </Heading>
        {shouldShowInsuranceStatus && isActiveInsurance && (
          <img
            style={{ width: '80px', height: '25px' }}
            src={InsuranceActiveStatusChip}
            alt={t('Insurance Active Status Chip')}
          />
        )}
        {shouldShowInsuranceStatus && isInActiveInsurance && (
          <img
            style={{ width: '85px', height: '25px' }}
            src={InsuranceInactiveStatusChip}
            alt={t('Insurance Inactive Status Chip')}
          />
        )}
      </div>
      <Logo />
    </section>
  );
});
PrintableHeader.displayName = 'PrintableHeader';

const printableHeaderStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: theme.spacing(2, 3),
});
